/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Benutzer } from '../models';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Ort } from '../models';
// @ts-ignore
import { Sprache } from '../models';
/**
 * RegistrierungService - axios parameter creator
 * @export
 */
export const RegistrierungServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Aktiviert einen neu registrierten Benutzer
         * @summary Benutzer Bestätigung
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmReg: async (token: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('confirmReg', 'token', token)
            const localVarPath = `/api/registrierung/confirm/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von LKZ\'s
         * @summary LkzSuche
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLkz: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/registrierung/lkz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Sprachen im der Applikation
         * @summary Alle Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprachen: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/registrierung/sprachen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Speichert einen neu registrierten Benutzer
         * @summary Benutzer Registrierung
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNewUser: async (benutzer: Benutzer, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'benutzer' is not null or undefined
            assertParamExists('registerNewUser', 'benutzer', benutzer)
            const localVarPath = `/api/registrierung`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(benutzer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sucht nach einem Ort mit PLZ oder Ortsnamen
         * @summary Ort Suche
         * @param {string} lkz 
         * @param {string} [plzOrName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrtWithPlzOrName: async (lkz: string, plzOrName?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lkz' is not null or undefined
            assertParamExists('searchOrtWithPlzOrName', 'lkz', lkz)
            const localVarPath = `/api/registrierung/{lkz}/ort`
                .replace(`{${"lkz"}}`, encodeURIComponent(String(lkz)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (plzOrName !== undefined) {
                localVarQueryParameter['plzOrName'] = plzOrName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrierungService - functional programming interface
 * @export
 */
export const RegistrierungServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrierungServiceAxiosParamCreator(configuration)
    return {
        /**
         * Aktiviert einen neu registrierten Benutzer
         * @summary Benutzer Bestätigung
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmReg(token: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Benutzer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmReg(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von LKZ\'s
         * @summary LkzSuche
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLkz(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLkz(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Sprachen im der Applikation
         * @summary Alle Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSprachen(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sprache>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSprachen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Speichert einen neu registrierten Benutzer
         * @summary Benutzer Registrierung
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerNewUser(benutzer: Benutzer, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Benutzer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerNewUser(benutzer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sucht nach einem Ort mit PLZ oder Ortsnamen
         * @summary Ort Suche
         * @param {string} lkz 
         * @param {string} [plzOrName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOrtWithPlzOrName(lkz: string, plzOrName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOrtWithPlzOrName(lkz, plzOrName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrierungService - factory interface
 * @export
 */
export const RegistrierungServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrierungServiceFp(configuration)
    return {
        /**
         * Aktiviert einen neu registrierten Benutzer
         * @summary Benutzer Bestätigung
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmReg(token: string, options?: any): AxiosPromise<Array<Benutzer>> {
            return localVarFp.confirmReg(token, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von LKZ\'s
         * @summary LkzSuche
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLkz(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAllLkz(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Sprachen im der Applikation
         * @summary Alle Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprachen(options?: any): AxiosPromise<Array<Sprache>> {
            return localVarFp.getSprachen(options).then((request) => request(axios, basePath));
        },
        /**
         * Speichert einen neu registrierten Benutzer
         * @summary Benutzer Registrierung
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNewUser(benutzer: Benutzer, options?: any): AxiosPromise<Array<Benutzer>> {
            return localVarFp.registerNewUser(benutzer, options).then((request) => request(axios, basePath));
        },
        /**
         * Sucht nach einem Ort mit PLZ oder Ortsnamen
         * @summary Ort Suche
         * @param {string} lkz 
         * @param {string} [plzOrName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrtWithPlzOrName(lkz: string, plzOrName?: string, options?: any): AxiosPromise<Array<Ort>> {
            return localVarFp.searchOrtWithPlzOrName(lkz, plzOrName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrierungService - interface
 * @export
 * @interface RegistrierungService
 */
export interface RegistrierungServiceInterface {
    /**
     * Aktiviert einen neu registrierten Benutzer
     * @summary Benutzer Bestätigung
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungServiceInterface
     */
    confirmReg(token: string, options?: any): AxiosPromise<Array<Benutzer>>;

    /**
     * Liefert eine Liste von LKZ\'s
     * @summary LkzSuche
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungServiceInterface
     */
    getAllLkz(options?: any): AxiosPromise<Array<string>>;

    /**
     * Liefert alle Sprachen im der Applikation
     * @summary Alle Sprachen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungServiceInterface
     */
    getSprachen(options?: any): AxiosPromise<Array<Sprache>>;

    /**
     * Speichert einen neu registrierten Benutzer
     * @summary Benutzer Registrierung
     * @param {Benutzer} benutzer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungServiceInterface
     */
    registerNewUser(benutzer: Benutzer, options?: any): AxiosPromise<Array<Benutzer>>;

    /**
     * Sucht nach einem Ort mit PLZ oder Ortsnamen
     * @summary Ort Suche
     * @param {string} lkz 
     * @param {string} [plzOrName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungServiceInterface
     */
    searchOrtWithPlzOrName(lkz: string, plzOrName?: string, options?: any): AxiosPromise<Array<Ort>>;

}

/**
 * RegistrierungService - object-oriented interface
 * @export
 * @class RegistrierungService
 * @extends {BaseAPI}
 */
export class RegistrierungService extends BaseAPI implements RegistrierungServiceInterface {
    /**
     * Aktiviert einen neu registrierten Benutzer
     * @summary Benutzer Bestätigung
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungService
     */
    public confirmReg(token: string, options?: any) {
        return RegistrierungServiceFp(this.configuration).confirmReg(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von LKZ\'s
     * @summary LkzSuche
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungService
     */
    public getAllLkz(options?: any) {
        return RegistrierungServiceFp(this.configuration).getAllLkz(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Sprachen im der Applikation
     * @summary Alle Sprachen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungService
     */
    public getSprachen(options?: any) {
        return RegistrierungServiceFp(this.configuration).getSprachen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Speichert einen neu registrierten Benutzer
     * @summary Benutzer Registrierung
     * @param {Benutzer} benutzer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungService
     */
    public registerNewUser(benutzer: Benutzer, options?: any) {
        return RegistrierungServiceFp(this.configuration).registerNewUser(benutzer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sucht nach einem Ort mit PLZ oder Ortsnamen
     * @summary Ort Suche
     * @param {string} lkz 
     * @param {string} [plzOrName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrierungService
     */
    public searchOrtWithPlzOrName(lkz: string, plzOrName?: string, options?: any) {
        return RegistrierungServiceFp(this.configuration).searchOrtWithPlzOrName(lkz, plzOrName, options).then((request) => request(this.axios, this.basePath));
    }
}
